// extracted by mini-css-extract-plugin
export default {"loader":"loader--fgTOr","layout":"layout--wwwuM","appear":"appear--rLCmu"};